/**
 * レイアウト関連の定数
 * 固定ヘッダーやサイドバーの高さなど、レイアウトに使用される値を一元管理します。
 */

// ヘッダーの高さ（px）
export const HEADER_HEIGHT = 50;

// モバイルヘッダーの高さ（px）
export const MOBILE_HEADER_HEIGHT = 50;

// 物件名部分の高さ（px）
export const PROPERTY_NAME_HEIGHT_DESKTOP = 70;
export const PROPERTY_NAME_HEIGHT_MOBILE = 70;

// タブナビゲーションの高さ（px）
export const TAB_NAVIGATION_HEIGHT = 30;

// 物件名部分のtop位置（px）
export const PROPERTY_NAME_TOP = HEADER_HEIGHT;

// タブナビゲーションのtop位置（px）
export const TAB_NAVIGATION_TOP_DESKTOP =
  HEADER_HEIGHT + PROPERTY_NAME_HEIGHT_DESKTOP;
export const TAB_NAVIGATION_TOP_MOBILE =
  HEADER_HEIGHT + PROPERTY_NAME_HEIGHT_MOBILE;

// タブコンテンツのpadding-top（px）
export const TAB_CONTENT_PADDING_TOP_DESKTOP = 100;
export const TAB_CONTENT_PADDING_TOP_MOBILE = 100;

// スクロールバーの高さ（px）
export const SCROLLBAR_HEIGHT = 4;

// スクロールバーの角丸（px）
export const SCROLLBAR_BORDER_RADIUS = 4;
